import { LanguageCode } from '@visikon/core-models/languageTypes';
import { Dropdown, DropdownProps, StrictDropdownItemProps } from 'semantic-ui-react';
import styled from 'styled-components';
import { getVoicesForLanguage } from './StaticVoiceData';
import type { SyntheticEvent } from 'react';
import { usePreferredVoice } from './UsePreferredVoice';

interface VoiceDropdownProps {
  activeLanguage: LanguageCode;
  onChange: (event: SyntheticEvent<HTMLElement>, data: DropdownProps) => void;
}

function getDropdownOptions(activeLanguage: LanguageCode): StrictDropdownItemProps[] {
  return getVoicesForLanguage(activeLanguage).map((voice, index) => ({
    key: voice.voice,
    value: voice.voice,
    text: voice.name,
    selected: index === 0,
  }));
}

export const VoiceDropdown = ({ activeLanguage, onChange }: VoiceDropdownProps) => {
  const prefered = usePreferredVoice({ selectedLanguage: activeLanguage });
  const options = getDropdownOptions(activeLanguage);
  const hideDropdown = options.length === 1;

  if (hideDropdown) {
    return null;
  }

  return <StyledDropdown placeholder="Select Voice" selection defaultValue={prefered.voiceId} options={options} onChange={onChange} />;
};

const StyledDropdown = styled(Dropdown)`
  margin: 0 0.5em;
  min-width: 11em;

  & i {
    margin: -0.78571429em !important;
  }
`;
